import { all, takeLeading } from "redux-saga/effects";
import { StoreTypes as PStoreTypes } from "../Stores/redux/Persist/Actions";
import { fetchMyProfile } from "./UserSaga";


export default function* root() {
  yield all([
    /**
     * @see https://redux-saga.js.org/docs/basics/UsingSagaHelpers.html
     */
    // Run the startup saga when the application starts
    // takeLatest(StartupTypes.STARTUP, startup),
    takeLeading(PStoreTypes.FETCH_MY_PROFILE, fetchMyProfile),
  ]);
}
